import React from 'react';
import { Field, reduxForm } from 'redux-form';
// import label from '../../utils/lngEn';
// import FormField from '../common/FormField';
// import Validate from '../common/formValidate';
import { Col, FormGroup, ControlLabel, Form, HelpBlock } from 'react-bootstrap';
import CheckboxField from '../form/CheckboxField';
import DropdownField from '../form/DropdownField';

class PublishAssignmentForm extends React.Component {
  render() {
    const handleSubmit = event => {
      event.preventDefault();
      this.props.handlePublishComputation();
    };

    const handleCancel = event => {
      event.preventDefault();
      this.props.handleCancel();
    }
    return (
      <Form horizontal className="assignment-data-form">
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={5}>
            Select assignment to publish:
          </Col>
          <Col sm={7}>
            <Field
              name="computationId"
              valueField="value"
              textField="option"
              data={this.props.computations}
              component={DropdownField}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col sm={12} className="btn-group btn-group-vertical p-0-5" data-toggle="buttons">
            <Field
              name="email_students"
              type="checkbox"
              normalize={value => !!value}
              component={CheckboxField}
              description={'Email students their schedules when assignment is published'}
            />
            <Field
              name="populate_waitlist"
              type="checkbox"
              normalize={value => !!value}
              component={CheckboxField}
              description={'Automatically populate waitlists'}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col sm={6}>
            <button className="btn btn-ter pull-left" onClick={handleCancel}>
              Cancel
            </button>
          </Col>
          <Col sm={6}>
            <button className="btn btn-block" type="submit" onClick={handleSubmit}>
              Publish assignment
            </button>
            <HelpBlock>Publishing an assignment is permanent and cannot be undone.</HelpBlock>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'PublishAssignmentForm'
})(PublishAssignmentForm);



// WEBPACK FOOTER //
// ./src/components/runs/PublishAssignmentForm.js